import React from 'react';
import tags from './tags';

const Tags = () => <div className="widget tags">{tags}</div>;

export default Tags;
